<script setup lang="ts">
const { groupedLocations, groupBy } = useMapState()!

const el = useTemplateRef<HTMLElement>('el')

const { y } = useScroll(el, { behavior: 'smooth' })

watch(groupBy, () => {
  y.value = 0
})
</script>

<template>
  <div ref="el" class="grid gap-4 overflow-y-auto">
    <LocationsListGroup
      v-for="group in groupedLocations"
      :key="group.label"
      :group="group"
    />
  </div>
</template>
